import React, { useState } from 'react';
import WhatsappOAuthService from '@Helpers/URLHelpers/WeboutService/WhatsappOAuthService';
import ErrorHandler from '@Root/ErrorHandler';
import './FacebookOAuthPage.scss';

const FacebookOAuthPage = () => {

    const [loading, setLoading] = useState(false);
    const whatsappOAuthService = new WhatsappOAuthService();
    const errorHandler = new ErrorHandler();

    const handleLogin = async () => {
        setLoading(true);
        try {
            let response = await whatsappOAuthService.oAuthLogin();
            if(response.status < 400) {
                let url = response.body;
                window.location.href = url;
            }
        } catch (err) {
            errorHandler.handleError(err);
        }
    };

    return (
        <div className="kzq-connect-whatsapp-container" style={{cursor: loading ? 'wait' : 'auto'}}>
            <div className="kzq-connect-whatsapp-card">
                <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp Logo" className="kzq-connect-whatsapp-logo" />
                <h2 className="kzq-connect-whatsapp-title">Connect WhatsApp</h2>
                <p className="kzq-connect-whatsapp-desc">Connect your WhatsApp account securely using Facebook OAuth to get started.</p>
                <button className={"kzq-connect-whatsapp-btn " + (loading ? " disabled" : ' ')} onClick={handleLogin} disabled={loading}>
                    Connect WhatsApp
                </button>
            </div>
        </div>
    );
};

export default FacebookOAuthPage;
